export const searchData = [
  {
    title: "Home",
    path: "/",
    keywords: ["Home", "TSG"],
    isPrivate: false,
  },
  {
    title: "Student Profile",
    path: "/profile",
    keywords: ["Profile", "Student", "My"],
    isPrivate: true,
  },
  {
    title: "TSG Events",
    path: "/events",
    keywords: ["Events"],
    isPrivate: false,
  },
  {
    title: "Society Point",
    path: "/socpoint",
    keywords: ["Societies", "Society", "Events"],
    isPrivate: false,
  },
  {
    title: "News",
    path: "/news",
    keywords: ["News", "Events", "Event"],
    isPrivate: false,
  },
  {
    title: "Student's Point",
    path: "/studpoint",
    keywords: ["Profile", "Academics", "Student", "year", "Study", "Semester"],
    isPrivate: false,
  },
  {
    title: "Quick Info",
    path: "/quickinfo",
    keywords: ["Stats", "Info"],
    isPrivate: false,
  },
  {
    title: "Societies",
    path: "/quickinfo/society",
    keywords: ["Society", "Cell", "Club", "Group"],
    isPrivate: false,
  },
  {
    title: "Halls of Residence",
    path: "/quickinfo/hallofresidance",
    keywords: ["Hall", "Residence"],
    isPrivate: false,
  },
  {
    title: "Departments",
    path: "/quickinfo/department",
    keywords: ["Department", "Dep", "Academics"],
    isPrivate: false,
  },
  {
    title: "General Championship",
    path: "/quickinfo/gc",
    keywords: ["Championship", "General", "GC"],
    isPrivate: false,
  },
  {
    title: "Contacts",
    path: "/quickinfo/contacts",
    keywords: ["Contacts"],
    isPrivate: false,
  },
  {
    title: "Quick Links",
    path: "/quickinfo/quicklinks",
    keywords: ["Links", "Info"],
    isPrivate: false,
  },
  {
    title: "Quick Links",
    path: "/quickinfo/quicklinks",
    keywords: ["Links", "Info"],
    isPrivate: false,
  },
  {
    title: "CDC Statistics",
    path: "/quickinfo/cdc",
    keywords: ["CDC", "Stats", "Statistics"],
    isPrivate: false,
  },
  {
    title: "Grade Statistics",
    path: "/quickinfo/grade",
    keywords: ["Grade", "Stats", "Statistics", "Grades"],
    isPrivate: false,
  },
  {
    title: "KGP Map",
    path: "/kgpmap",
    keywords: ["Map", "Location", "Campus", "KGP"],
    isPrivate: false,
  },
];
